import { Button } from "./ui/button";

const ContactBanner = ({onPageChange} : {onPageChange: (page: string) => void}) => {
  return (
    <div className="relative text-white rounded-lg shadow-lg py-4 px-20 flex items-center justify-between w-[80vw] mx-auto h-[50vh]"
      style={{
        background: 'linear-gradient(to bottom right, rgba(159, 243, 71, 0.2), rgba(0, 0, 0, 0.5)), url("https://plus.unsplash.com/premium_photo-1729070677283-c16a03fe5287?q=80&w=1228&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D")',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}>
      <div className="flex items-center space-x-4">
        <div className="w-full">
          <p className="text-md text-green-200">Interested ?</p>
          <h2 className="text-5xl font-bold">Connect with us today - your collaboration shapes the future!</h2>
        </div>
      </div>
       <Button
         size="lg"
         variant="outline"
         onClick={() => onPageChange("contact")}
         className="action border-2 border-white text-white hover:bg-amber-400 hover:border-amber-400 hover:text-white !px-12 py-6 rounded-3xl text-lg font-semibold backdrop-blur-sm bg-white/10 transition-all duration-300"
       >
         Contact Us
       </Button>
    </div>
  );
};

export default ContactBanner;